/**
 * @file WithFEMSOverview.jsx
 * @description 공장에너지관리시스템(FEMS) 소개 페이지입니다.
 */

export default function WithFEMSOverview() {
  return (
    <>
      {/* ============== HERO ============== */}
      <section className="hero fems" style={{ paddingTop: '72px' }}>
        <div className="container hero-inner">
          <div>
            <span className="section-eyebrow">Factory Energy Management System</span>
            <h1>
              에너지 사용을<br />
              측정·분석·예측합니다.
              <span className="sys">Factory Energy Management System</span>
            </h1>
            <p className="lead">
              전력·가스·스팀·이·용수 사용량을 계측해 비용과 탄소 배출량을 계산하고,
              KPI와 AI 예측까지 한 시스템에서 다룹니다.
            </p>

            <div className="hero-stats">
              <div className="hero-stat">
                <div className="num">5</div>
                <div className="lbl">전력·가스·스팀·이·용수</div>
              </div>
              <div className="hero-stat">
                <div className="num">6</div>
                <div className="lbl">에너지 KPI 지표</div>
              </div>
              <div className="hero-stat">
                <div className="num">AI</div>
                <div className="lbl">사용량 예측</div>
              </div>
            </div>
          </div>

          {/* Dashboard mock */}
          <div className="preview" aria-hidden="true">
            <div className="preview-bar">
              <span className="preview-dot"></span><span className="preview-dot"></span><span className="preview-dot"></span>
              <span className="preview-url">withFEMS · 대시보드 / 청주공장</span>
            </div>
            <div style={{ padding: 0, background: '#fafbfd' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px', background: 'white', borderBottom: '1px solid #eef1f7' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '22px', height: '22px', borderRadius: '6px', background: 'var(--amber)', display: 'grid', placeItems: 'center', color: 'white', fontWeight: 800, fontSize: '10px' }}>F</div>
                  <div style={{ fontSize: '13px', fontWeight: 700 }}>withFEMS <span style={{ color: 'var(--muted)', fontWeight: 500 }}>/ 대시보드</span></div>
                </div>
                <div style={{ fontSize: '11px', color: 'var(--muted)' }}>2026.05.21 · 관리자[admin]</div>
              </div>

              <div className="fems-hero-kpi-grid">
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">금일 전력사용</div>
                  <div className="val" style={{ fontSize: '20px' }}>12,486<span className="unit">kWh</span></div>
                  <div className="sub" style={{ color: 'var(--amber-2)' }}>전일 대비 +3.2%</div>
                </div>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">최대 수요전력</div>
                  <div className="val" style={{ fontSize: '20px' }}>842<span className="unit">kW</span></div>
                  <div className="sub">15:00~15:15</div>
                </div>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">금일 에너지요금</div>
                  <div className="val" style={{ fontSize: '20px' }}>1,932<span className="unit">천원</span></div>
                  <div className="sub">기본·전력량·역률</div>
                </div>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">탄소 배출량</div>
                  <div className="val" style={{ fontSize: '20px' }}>5.74<span className="unit">tCO₂e</span></div>
                  <div className="sub">Scope2 기준</div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: '10px', padding: '0 14px 14px' }}>
                <div className="kpi-tile" style={{ padding: '14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontSize: '12px', fontWeight: 700 }}>전력 부하 (kW) · 금일</div>
                    <div style={{ fontSize: '10px', color: 'var(--muted)' }}>계약전력 1,000kW</div>
                  </div>
                  <svg width="100%" height="120" viewBox="0 0 320 120" preserveAspectRatio="none" style={{ marginTop: '6px' }}>
                    <defs>
                      <linearGradient id="loadGradFems" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0%" stopColor="#d97706" stopOpacity=".22" />
                        <stop offset="100%" stopColor="#d97706" stopOpacity="0" />
                      </linearGradient>
                    </defs>
                    <line x1="0" y1="32" x2="320" y2="32" stroke="#d92d20" strokeWidth="1" strokeDasharray="3 3" />
                    <text x="4" y="28" fontSize="9" fill="#d92d20">계약 90%</text>
                    <path className="fems-hero-area" d="M0 96 L20 88 L40 92 L60 80 L80 72 L100 58 L120 50 L140 44 L160 38 L180 34 L200 28 L220 36 L240 46 L260 52 L280 60 L300 70 L320 78 L320 120 L0 120 Z" fill="url(#loadGradFems)" />
                    <path className="fems-hero-line" pathLength="1" d="M0 96 L20 88 L40 92 L60 80 L80 72 L100 58 L120 50 L140 44 L160 38 L180 34 L200 28 L220 36 L240 46 L260 52 L280 60 L300 70 L320 78" stroke="#d97706" strokeWidth="2" fill="none" strokeLinecap="round" />
                    <circle className="fems-hero-dot" cx="200" cy="28" r="3.5" fill="#d97706" />
                    <g fontFamily="inherit" fontSize="9" fill="#8a96ac">
                      <text x="0" y="115">00</text>
                      <text x="78" y="115">06</text>
                      <text x="156" y="115">12</text>
                      <text x="234" y="115">18</text>
                      <text x="304" y="115">24</text>
                    </g>
                  </svg>
                </div>
                <div className="kpi-tile" style={{ padding: '14px' }}>
                  <div style={{ fontSize: '12px', fontWeight: 700, marginBottom: '8px' }}>에너지원별 비중</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[
                      { label: '전력',      pct: '62%', color: 'var(--amber)' },
                      { label: '가스 (LNG)', pct: '18%', color: '#1c8de4' },
                      { label: '스팀',      pct: '12%', color: '#6f48d5' },
                      { label: '이',        pct: '5%',  color: '#16a34a' },
                      { label: '용수',      pct: '3%',  color: '#62718a' },
                    ].map((e) => (
                      <div key={e.label}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px' }}>
                          <span>{e.label}</span><span style={{ color: 'var(--muted)' }}>{e.pct}</span>
                        </div>
                        <div style={{ height: '5px', background: '#eef1f7', borderRadius: '3px', marginTop: '3px', overflow: 'hidden' }}>
                          <div style={{ width: e.pct, height: '100%', background: e.color }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============== FEATURES ============== */}
      <section className="section" id="features">
        <div className="container">
          <div className="section-head">
            <span className="section-eyebrow">Key Features</span>
            <h2>계측에서 비용·탄소·예측까지,<br />에너지 관리의 전 과정.</h2>
            <p>모니터링·알람·비용·탄소·KPI·AI 분석 — 에너지 이이에 필요한 업무를 하나의 절차로 묶었습니다.</p>
          </div>

          <div className="grid-3">
            {[
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
                color: 'amber', title: '에너지 모니터링',
                desc: '전력·가스·스팀·이·용수 계측 데이터를 수집해 현황화면에 실시간으로 보여 줍니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 8a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M10 18a2 2 0 1 0 4 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'amber', title: '에너지 알람',
                desc: '임계치를 벗어나는 계측 값이 발생하면 사용자에게 자동 통지합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3v18m4-15c-1-1.5-2.5-2-4-2-2 0-4 1-4 3s2 2.5 4 3 4 1 4 3-2 3-4 3c-1.5 0-3-.5-4-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'amber', title: '에너지 비용 계산',
                desc: '요금 기준을 등록하면 계측기별·공장 전체의 에너지 사용 비용을 계산합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 21a9 9 0 1 0-9-9c0 2 1 4 2 5l7-12 7 12c1-1 2-3 2-5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
                color: 'amber', title: '탄소 배출량 계산',
                desc: '에너지원별 배출계수를 적용해 계측기별·공장 전체의 탄소 배출량을 산출합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 20V10m6 10V4m6 16v-8m6 8v-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'navy', title: '에너지 KPI',
                desc: '생산량대비 에너지, 가동시간대비 에너지, 최대 수요전력, 부하율 등 표준 지표를 조회합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 17h4l3-10 4 14 3-7h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
                color: '', title: '피크 전력 조회',
                desc: '계약전력의 90% 수준을 초과한 계측 그룹과 시간을 찾아 보여 줍니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2 2m8.8 8.8 2 2M5.6 18.4l2-2m8.8-8.8 2-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'navy', title: 'AI 피크 분석',
                desc: '설비 이이 데이터와 피크 전력 간 상관성을 분석해 원인 설비를 식별합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 12c2-6 7-8 12-3M21 6v5h-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M21 12c-2 6-7 8-12 3M3 18v-5h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
                color: 'navy', title: 'AI 사용량 예측',
                desc: '과거 사용 패턴을 학습해 미래의 에너지 사용량을 예측합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8"/><path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: '', title: '기준정보',
                desc: '전기·가스·스팀·이·용수 요금과 탄소배출계수를 한 곳에서 관리합니다.',
              },
            ].map((f) => (
              <div key={f.title} className="feature">
                <div className={`icon${f.color ? ` ${f.color}` : ''}`}>{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============== COST & CARBON ============== */}
      <section className="section soft">
        <div className="container split">
          <div>
            <span className="section-eyebrow">Cost · Carbon</span>
            <h3 style={{ marginTop: '14px' }}>에너지 사용이 곧 비용이고, 곧 배출입니다.</h3>
            <p>계측된 사용량을 그대로 비용과 탄소 배출량으로 환산해, 일별·월별로 조회할 수 있습니다. 계측기 단위와 공장 단위 모두 지원합니다.</p>
            <ul className="bullets amber">
              <li>요금 기준 — 기본요금 · 전력량 요금 · 역률 보정</li>
              <li>탄소배출계수 — 에너지원별 적용</li>
              <li>일별 / 월별 — 에너지요금 · 탄소배출 조회</li>
              <li>계측기별 · 공장 전체 보기</li>
            </ul>
          </div>

          <div className="preview">
            <div className="preview-bar">
              <span className="preview-dot"></span><span className="preview-dot"></span><span className="preview-dot"></span>
              <span className="preview-url">withFEMS · 월별 에너지요금</span>
            </div>
            <div style={{ padding: 0 }}>
              <div style={{ padding: '16px 18px 12px', borderBottom: '1px solid var(--line-2)', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <div>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>2026년 4월 · 청주공장</div>
                  <div style={{ fontSize: '22px', fontWeight: 700, letterSpacing: '-.02em', marginTop: '2px' }}>58,420<span style={{ fontSize: '13px', color: 'var(--muted)', fontWeight: 500, marginLeft: '4px' }}>천원</span></div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>탄소 배출 (Scope2)</div>
                  <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--text)', marginTop: '2px' }}>172.4<span style={{ fontSize: '11px', color: 'var(--muted)', marginLeft: '4px' }}>tCO₂e</span></div>
                </div>
              </div>
              <table className="table">
                <thead>
                  <tr><th>에너지원</th><th>사용량</th><th className="right">요금 (천원)</th><th className="right">tCO₂e</th></tr>
                </thead>
                <tbody>
                  <tr><td>전력</td><td className="mono">362,480 kWh</td><td className="right mono">36,248</td><td className="right mono">144.8</td></tr>
                  <tr><td>가스 (LNG)</td><td className="mono">12,840 Nm³</td><td className="right mono">14,124</td><td className="right mono">23.8</td></tr>
                  <tr><td>스팀</td><td className="mono">486 t</td><td className="right mono">5,832</td><td className="right mono">2.9</td></tr>
                  <tr><td>이</td><td className="mono">1,240 GJ</td><td className="right mono">1,488</td><td className="right mono">0.7</td></tr>
                  <tr><td>용수</td><td className="mono">2,860 t</td><td className="right mono">728</td><td className="right mono">0.2</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* ============== KPI & AI ============== */}
      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="section-eyebrow">KPI · AI Analysis</span>
            <h2>표준 KPI 그리고 AI 예측을<br />같은 데이터 위에서.</h2>
            <p>같은 계측 데이터를 기반으로 표준 KPI와 AI 분석을 함께 제공합니다.</p>
          </div>

          <div className="grid-2" style={{ gap: '20px' }}>
            <div className="arch" style={{ padding: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '14px' }}>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '.06em', color: 'var(--muted)', textTransform: 'uppercase' }}>에너지 KPI</div>
                  <div style={{ fontSize: '18px', fontWeight: 700, marginTop: '2px' }}>표준 6 지표</div>
                </div>
              </div>

              <div className="grid-2" style={{ gap: '10px' }}>
                <div className="kpi-tile">
                  <div className="label">단위 생산량대비 에너지</div>
                  <div className="val">0.42<span className="unit">kWh/EA</span></div>
                  <div className="sub">정제 라인 · 4월</div>
                </div>
                <div className="kpi-tile">
                  <div className="label">가동시간대비 에너지</div>
                  <div className="val">186<span className="unit">kWh/h</span></div>
                  <div className="sub">평균 · 4월</div>
                </div>
                <div className="kpi-tile">
                  <div className="label">최대 수요전력</div>
                  <div className="val">842<span className="unit">kW</span></div>
                  <div className="sub">2026-04-18 15:00</div>
                </div>
                <div className="kpi-tile">
                  <div className="label">부하율 (Load Factor)</div>
                  <div className="val">68.4<span className="unit">%</span></div>
                  <div className="sub">평균 ÷ 최대</div>
                </div>
              </div>
            </div>

            <div className="arch" style={{ padding: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '14px' }}>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '.06em', color: 'var(--muted)', textTransform: 'uppercase' }}>AI 분석</div>
                  <div style={{ fontSize: '18px', fontWeight: 700, marginTop: '2px' }}>사용량 예측 · 피크 상관성</div>
                </div>
              </div>

              <div style={{ background: 'var(--bg-soft)', borderRadius: '10px', padding: '14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--muted)', marginBottom: '6px' }}>
                  <span>전력 사용량 (kWh) · 다음 7일 예측</span>
                  <span>
                    <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', background: 'var(--blue)', marginRight: '4px' }}></span>실측
                    <span style={{ display: 'inline-block', width: '10px', height: '2px', background: 'var(--amber)', margin: '0 4px 0 8px', verticalAlign: 'middle' }}></span>예측
                  </span>
                </div>
                <svg width="100%" height="130" viewBox="0 0 400 130" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="predGrad" x1="0" x2="0" y1="0" y2="1">
                      <stop offset="0%" stopColor="#1c8de4" stopOpacity=".25" />
                      <stop offset="100%" stopColor="#1c8de4" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="predGrad2" x1="0" x2="0" y1="0" y2="1">
                      <stop offset="0%" stopColor="#d97706" stopOpacity=".18" />
                      <stop offset="100%" stopColor="#d97706" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <line x1="200" y1="0" x2="200" y2="120" stroke="#cbd2e0" strokeWidth="1" strokeDasharray="3 3" />
                  <text x="195" y="14" textAnchor="end" fontSize="9" fill="#62718a">실측</text>
                  <text x="205" y="14" fontSize="9" fill="#d97706">예측</text>
                  <path d="M0 70 L 25 60 L 50 78 L 75 56 L 100 64 L 125 50 L 150 72 L 175 58 L 200 66 L 200 120 L 0 120 Z" fill="url(#predGrad)" />
                  <path d="M0 70 L 25 60 L 50 78 L 75 56 L 100 64 L 125 50 L 150 72 L 175 58 L 200 66" stroke="#1c8de4" strokeWidth="2" fill="none" />
                  <path d="M200 66 L 225 58 L 250 70 L 275 52 L 300 60 L 325 46 L 350 64 L 375 50 L 400 56 L 400 120 L 200 120 Z" fill="url(#predGrad2)" />
                  <path d="M200 66 L 225 58 L 250 70 L 275 52 L 300 60 L 325 46 L 350 64 L 375 50 L 400 56" stroke="#d97706" strokeWidth="2" fill="none" strokeDasharray="4 3" />
                  <g fontFamily="inherit" fontSize="9" fill="#8a96ac">
                    <text x="0" y="128">-7d</text>
                    <text x="196" y="128">today</text>
                    <text x="380" y="128">+7d</text>
                  </g>
                </svg>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '14px' }}>
                <div style={{ padding: '12px', border: '1px solid var(--line)', borderRadius: '10px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>피크 상관성</div>
                  <div style={{ fontSize: '13px', fontWeight: 700, marginTop: '4px' }}>건조기 가동률 ↑<br />피크 ↑ · r = 0.84</div>
                </div>
                <div style={{ padding: '12px', border: '1px solid var(--line)', borderRadius: '10px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>다음 주 사용량 예측</div>
                  <div style={{ fontSize: '13px', fontWeight: 700, marginTop: '4px' }}>85,200 kWh<br />± 4.2%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
